import { WhySpaceMemberList } from '@tribeplatform/react-components/MemberList'

import { BC } from '../../types/index.js'
import { SpaceMemberListProps } from './types.js'

/**
 * @deprecated use MembersBlock instead
 */
export const SpaceMemberListBlock: BC<SpaceMemberListProps> = WhySpaceMemberList
